import api from '@/utils/api'

export default {
    getActiveHours(page, perPage, field, order) {
        const sort = (field && order) ? [field, order] : []
        const query =
            `sort=${JSON.stringify(sort)}&` +
            `range=${JSON.stringify([page - 1, perPage])}`
        return api.get(`active-hours?${encodeURI(query)}`)
    },
    updateActiveHour(activeHour, id) {
        return api.put(`active-hours/${id}`, activeHour)
    },
    deleteActiveHour(id) {
        return api.delete(`active-hours/${id}`)
    },
    createActiveHour(activeHour) {
        return api.post('active-hours', activeHour)
    }
}
